import type { ImageDto } from "$src/core/models/dto";

const pickImageUrl = (
  image: ImageDto,
  importances: ("landscape" | "portrait" | "square")[],
) => {
  for (const importance of importances) {
    if (image[importance] && typeof image[importance] === "object") {
      return image[importance].url;
    }
  }
  return image.url;
};

export default pickImageUrl;
